import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import _ from 'lodash'

import { InspectionPlanModel } from '../../shared/model/inspection-plan.model';
import { ConfirmComponent } from '../../shared/component/confirm/confirm.component';
import { InspectionPlanService } from '../../shared/service/inspection-plan.service';
import { InspectionPlanModalComponent } from './inspection-plan-modal/inspection-plan-modal.component';

@Component({
	styleUrls: [],
	selector: 'app-inspection-plan-form',
	templateUrl: './inspection-plan-form.component.html',
})
export class InspectionPlanFormComponent implements OnInit {
	@ViewChild(ConfirmComponent) confirm: ConfirmComponent;
	@ViewChild(InspectionPlanModalComponent) inspectionPlanModal: InspectionPlanModalComponent;

	@Input() inspection_plans: InspectionPlanModel[];
	@Output() inspections = new EventEmitter<InspectionPlanModel[]>();
	
	// on edit
	verify: number = 0;
	weight: number = 0;
	keep_status: number = 0;
	inspectionPlanId: number = 0;

	// list
	unconformities: any[] = [];
	inspectionPlansRaw: any[] = [];
	inspectionPlanOptions: any[] = [];

	constructor(private inspectionService: InspectionPlanService) {}

	ngOnInit() {
		this.loadInspectionPlans();
	}

	loadInspectionPlans() {
		this.inspectionPlanOptions = [];

    this.inspectionService.getPaginated({
			init: 0, end: 1e+9
		})
    .subscribe(({ rows: inspections }) => {
      if (inspections && inspections.length) {
				this.inspectionPlansRaw = inspections;
				this.inspectionPlanOptions.push({ label: '', value: null });

				inspections.forEach(insp => {
					if (insp && insp.id) this.inspectionPlanOptions.push({
						label: insp.name || insp.description || 'Sem Descricao',
						value: insp.id,
					});
				});
			}

    });
	}

	onSaveInspectionPlan({ id: inspectionId, unc: unconformities, weight, verify, keep_status }) {
		const inspection = this.inspectionPlansRaw.find(ip => ip.id == inspectionId);

		if (!inspection && !inspection.id) return console.error('InvalidInspection');
		if (!this.inspection_plans) this.inspection_plans = []; // validation

		// filter existent unconformities
		inspection.unconformities = unconformities && unconformities.reduce((acc, current) => {
			if (!acc.find(item => item.id === current.id)) acc.push(current); return acc;
		}, []) || [];

		if (
			!this.inspection_plans.length ||
			!this.inspection_plans.some(ip => ip.id == inspectionId)
		) {
			this.inspection_plans.push(inspection);
		} else {
			const index = this.inspection_plans.findIndex(ip => ip.id == inspectionId);

			if (index == 0 || index && index > -1) {
				this.inspection_plans[index] = inspection;
			}
		}

		// setting weight
		if (inspection) {
			this.weight = weight;
			this.verify = verify;
			this.keep_status = keep_status;

			inspection.weight = weight;
			inspection.verify = verify;
			inspection.keep_status = keep_status;
		}

		// on edit
		if (this.inspectionPlanId && this.inspectionPlanId != inspectionId) {
			this.inspection_plans = this.inspection_plans.filter(ip => ip.id != this.inspectionPlanId);
		}

		this.saveInspections();
	}

	saveInspections() {
		this.inspections.emit(this.inspection_plans);
		this.inspectionPlanModal.display = false;
	}

	deleteInspectionPlan(inspectionId) {
		this.inspection_plans = this.inspection_plans.filter(ip => ip.id != inspectionId);

		this.saveInspections();
	}

	openModal(inspection?) {
		this.unconformities = inspection && inspection.unconformities || [];
		this.inspectionPlanId = inspection && inspection.id || 0;

		this.keep_status = inspection && inspection.keep_status || 0;
		this.verify = inspection && inspection.verify || 0;
		this.weight = inspection && inspection.weight || 0;

		this.inspectionPlanModal.display = true;
	};
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/checklist-form/inspection-plan-form/inspection-plan-form.component.ts